import React, { useRef, useEffect, useState } from "react";
import { styleGenerators } from "../utils/calendarUtils";

const CalendarHeader = React.memo(({ calendarData, gridConfig }) => {
  const yearMonthRef = useRef(null);
  const dayHeaderRef = useRef(null);
  const [heights, setHeights] = useState({ row1: 0, row2: 0 });

  useEffect(() => {
    const updateHeights = () => {
      if (yearMonthRef.current && dayHeaderRef.current) {
        setHeights({
          row1: yearMonthRef.current.offsetHeight,
          row2: dayHeaderRef.current.offsetHeight,
        });
      }
    };

    updateHeights();
    window.addEventListener("resize", updateHeights);
    return () => window.removeEventListener("resize", updateHeights);
  }, [calendarData]);

  return (
    <>
      {/* Production Line Header - spans 3 rows, sticks at top */}
      <div
        style={{
          ...styleGenerators.getProductionListStyle(gridConfig.lineListColumns),
          position: "sticky",
          top: 0,
          zIndex: 102,
          backgroundColor: "#D5EEFF",
        }}
      >
        <p
          style={{
            transform: "rotate(270deg)",
            whiteSpace: "nowrap",
            marginTop: "15px",
          }}
        >
          Production Line
        </p>
      </div>

      {/* Year-Month Header - Row 1 */}
      <div
        ref={yearMonthRef}
        style={{
          ...styleGenerators.getHeaderYearMonthStyle(gridConfig.days, gridConfig.lineListColumns),
          position: "sticky",
          top: 0,
          zIndex: 101,
          backgroundColor: "#D5EEFF",
        }}
      >
        {calendarData.calendarHeader.year} - {calendarData.calendarHeader.month}
      </div>

      {/* Day Headers - Row 2 */}
      {calendarData.calendarHeader.days.map((day, index) => {
        const dayStyle = styleGenerators.getHeaderDayStyle(gridConfig.dayWithDutyColumns, day);
        return (
          <div
            key={`day-${index}`}
            ref={index === 0 ? dayHeaderRef : null}
            style={{
              ...dayStyle,
              position: "sticky",
              top: heights.row1 || 0,
              zIndex: 101,
            }}
          >
            {day.day}
          </div>
        );
      })}

      {/* Weekday Headers - Row 3 */}
      {calendarData.calendarHeader.days.map((day, index) => {
        const dayStyle = styleGenerators.getHeaderDayStyle(gridConfig.dayWithDutyColumns, day);
        return (
          <div
            key={`weekday-${index}`}
            style={{
              ...dayStyle,
              position: "sticky",
              top: (heights.row1 || 0) + (heights.row2 || 0),
              zIndex: 101,
            }}
          >
            {day.weekday}
          </div>
        );
      })}
    </>
  );
});

CalendarHeader.displayName = "CalendarHeader";

export default CalendarHeader;
